/* eslint-disable react/no-find-dom-node */
import React from "react"
import { findDOMNode } from "react-dom"

const MAX_ATTRIBUTE_ATTEMPTS = 20
const ATTRIBUTE_RETRY_DELAY = 50

export default class StoryblokEditable extends React.PureComponent {
  retryTimeout = null

  componentDidMount() {
    this.applyEditableAttributes()
  }

  componentDidUpdate() {
    this.applyEditableAttributes()
  }

  componentWillUnmount() {
    this.clearRetryTimeout()
  }

  applyEditableAttributes(attempt = 0) {
    if (!isStoryblokEditor() || !this.props.content?._editable) {
      return
    }

    const options = getEditableOptions(this.props.content._editable)

    if (!options?.id || !options?.uid) {
      return
    }

    const element = findDOMNode(this)

    if (element instanceof Element && typeof element.setAttribute === "function") {
      this.clearRetryTimeout()
      element.setAttribute("data-blok-c", JSON.stringify(options))
      element.setAttribute("data-blok-uid", `${options.id}-${options.uid}`)
      element.classList.add("storyblok__outline")
      return
    }

    if (attempt < MAX_ATTRIBUTE_ATTEMPTS) {
      this.clearRetryTimeout()
      this.retryTimeout = window.setTimeout(
        () => this.applyEditableAttributes(attempt + 1),
        ATTRIBUTE_RETRY_DELAY,
      )
    }
  }

  clearRetryTimeout() {
    if (this.retryTimeout) {
      window.clearTimeout(this.retryTimeout)
      this.retryTimeout = null
    }
  }

  render() {
    return this.props.children
  }
}

function isStoryblokEditor() {
  if (typeof window === "undefined") {
    return false
  }

  return window.location.search.includes("_storyblok")
}

function getEditableOptions(editable) {
  if (typeof editable === "object") {
    return editable
  }

  if (typeof editable !== "string") {
    return null
  }

  try {
    return JSON.parse(editable.replace(/^<!--#storyblok#/, "").replace(/-->$/, ""))
  } catch {
    return null
  }
}
